// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"596":"404","773":"welcome"}[chunkId] + "." + {"596":"1a3aefad","773":"19ca8d29"}[chunkId] + ".css";
};